/* eslint "react/display-name": "warn" */
import React from 'react'
import { Box } from '@realsoftworks/decor'

export default props => (
  <Box {...props}>Loading...</Box>
)
